import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63dbfbeb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "app-main-full-height"
}
const _hoisted_3 = { class: "dialog-footer" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-plus fas" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sampling_point_list_component = _resolveComponent("sampling-point-list-component")!
  const _component_sampling_point_map_component = _resolveComponent("sampling-point-map-component")!
  const _component_sampling_point_form_component = _resolveComponent("sampling-point-form-component")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_page_buttons_component = _resolveComponent("page-buttons-component")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.showMap)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_sampling_point_list_component, {
            ref: "entityList",
            canWrite: _ctx.listCanWrite,
            appIsAdminAndRoleIsAdmin: _ctx.appIsAdminAndRoleIsAdmin
          }, null, 8, ["canWrite", "appIsAdminAndRoleIsAdmin"])
        ], 512)), [
          [_vShow, !_ctx.showMap]
        ])
      : _createCommentVNode("", true),
    (_ctx.showMap)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_sampling_point_map_component, { ref: "samplingMap" }, null, 512)
        ], 512)), [
          [_vShow, _ctx.showMap]
        ])
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.showEntityForm,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showEntityForm) = $event)),
        title: _ctx.$t(_ctx.entityForm?.id ? 'label.samplingPointsEdit' : 'label.samplingPointNew'),
        width: "50%",
        "destroy-on-close": "",
        "custom-class": "app-form"
      }, {
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_3, [
            _createVNode(_component_el_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeEntityFormDialog()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("btn.cancel")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveEntity()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("btn.save")), 1)
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_sampling_point_form_component, {
            ref: "entityForm",
            id: _ctx.entityForm?.id
          }, null, 8, ["id"])
        ]),
        _: 1
      }, 8, ["modelValue", "title"]),
      _createVNode(_component_page_buttons_component, null, {
        default: _withCtx(() => [
          (_ctx.canCreate)
            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 0,
                effect: "dark",
                content: _ctx.$t('btn.create'),
                placement: "left"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    class: "btn",
                    type: "primary",
                    size: "large",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openEntityFormDialog())),
                    circle: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["content"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_tooltip, {
            effect: "dark",
            content: _ctx.showMap ? _ctx.$t('btn.changeViewModeList') : _ctx.$t('btn.changeViewModeMap'),
            placement: "left"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                class: "btn",
                type: "primary",
                size: "large",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeView())),
                circle: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("em", {
                    class: _normalizeClass(_ctx.showMap ? 'el-icon el-icon-list fas' : 'el-icon el-icon-map fas')
                  }, null, 2)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["content"])
        ]),
        _: 1
      })
    ])
  ]))
}